import { render } from "./FlightPoliciesBanner.vue?vue&type=template&id=163c76c1"
import script from "./FlightPoliciesBanner.vue?vue&type=script&lang=js"
export * from "./FlightPoliciesBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__